<template>
  <span>
    <sidebar-module-info
      ref="sidebarModuleInfo"
      module-name="zdm_failures"
      permissions-path="ZDM_FAILURES"
      :custom-card-title="customCardTitle"
      :filtered-attributes="filteredAttributes"
      property-tittle-appendix="ZgloszenieNumer"
      :module-objects="failures"
      :get-object="getFailureObject"
      :handle-object-editing="handleFailureEditing"
      :init-gets="initGets"
      :inputs="inputs"
      has-back-button
      has-basic-attributes
      :has-deleting-objects="false"
      :has-add="false"
      :has-assigned-objects="false"
    >
      <template #ZgloszenieStatus="scope">
        <sidebar-status-select v-bind="scope" v-model="scope.payload[scope.name]" :isEditingOn="false" />
      </template>
      <template #NadawcaNazwa="scope">
        <div v-bind="scope">
          {{ scope.payload[scope.name] }}
        </div>
      </template>
      <template #OdbiorcaNazwa="scope">
        <div v-bind="scope">
          {{ scope.payload[scope.name] }}
        </div>
      </template>
      <template #ZgloszenieTresc="scope">
        <div v-bind="scope">
          {{ scope.payload[scope.name] }}
        </div>
      </template>
      <template #Przyjmujacy="scope">
        <div v-bind="scope">
          {{ scope.payload[scope.name] }}
        </div>
      </template>
      <template #UlicaNazwa="scope">
        <div v-bind="scope">
          {{ scope.payload[scope.name] }}
          <v-icon color="primary" size="18" @click="zoomToStreet(scope.payload[scope.name])" class="pl-1">
            mdi-magnify
          </v-icon>
          <div class="subHeader">
            {{ scope.payload['ZgloszenieOdcinek'] }}
          </div>
        </div>
      </template>
      <template #extraContent="payload">
        <ZDMFailuresDateHistory :dates="getDates(payload)" />
      </template>
    </sidebar-module-info>
    <main-dialog
      v-if="isDialogLoaded"
      :is-visible.sync="isDialogVisible"
      :title="$i18n.t('dialog.title.searchInGoogle')"
      :body="$i18n.t('dialog.body.searchInGoogleBody', { name })"
      agree-text="dialog.agreeSearch"
      @agree="searchInGoogle"
    />
  </span>
</template>
<script>
import { call, get } from 'vuex-pathify';

import SidebarModuleInfo from '@/components/SidebarModuleInfo';
import SidebarStatusSelect from '@/components/SidebarStatusSelect';
import ZDMFailuresDateHistory from '@/components/ZDMFailuresDateHistory';

export default {
  name: 'Failure',
  components: {
    MainDialog: () => import('@/components/MainDialog'),
    ZDMFailuresDateHistory,
    SidebarModuleInfo,
    SidebarStatusSelect,
  },
  data: () => ({
    name: '',
    isDialogLoaded: false,
    isDialogVisible: false,
    filteredAttributes: [
      'ZgloszenieId',
      'ZgloszenieNumer',
      'ZgloszenieDataPrzyjecia',
      'UlicaNazwa',
      'ZgloszenieOdcinek',
      'ZgloszenieTresc',
      'ZgloszenieDataPrzekazania',
      'ZgloszenieDataPotwierdzenia',
      'NadawcaNazwa',
      'OdbiorcaNazwa',
      'ZgloszenieStatus',
      'Przyjmujacy',
    ],
  }),
  computed: {
    failures: get('zdmFailures/failures'),
    dataSource: get('admin/modulesMapping@zdm_failures.datasource_name'),
    currentLayerFormSchema: get('layers/currentLayer@form_schema'),
    dataSourcesForms: get('layers/dataSourcesForms@:dataSource'),
    attributesMetadata: get('layers/metadata@:dataSource'),
    zdmLayers: get('admin/modulesMapping@zdm_data.layers'),
    zdmLayersArray() {
      return this.$_objectToArray(this.zdmLayers);
    },
    newFailureObject() {
      return {};
    },
    customCardTitle() {
      return {
        new: '',
        edit: this.$i18n.t('dialog.zdmFailureCardTitle'),
      };
    },
    inputs() {
      return {
        new: [],
        edit: [
          {
            name: 'ZgloszenieStatus',
            translationPath: 'dialog.status',
            icon: 'mdi-progress-check',
            cols: 'auto',
            type: 'zdm_failures',
            colors: {
              potwierdzone: {
                color: 'rgba(24,128,56)',
                shadowColor: 'rgba(24,128,56,0.2)',
              },
              przekazane: {
                color: 'rgba(255,136,0)',
                shadowColor: 'rgba(255,136,0,0.2)',
              },
              przyjete: {
                color: 'rgba(0,145,234)',
                shadowColor: 'rgba(0,145,234,0.2)',
              },
            },
            rules: [v => !!v || v == '0' || 'rules.required'],
          },
          {
            name: 'UlicaNazwa',
            translationPath: 'sidebar.streetName',
            icon: 'mdi-road-variant',
            class: 'plainText',
          },
          {
            name: 'ZgloszenieTresc',
            translationPath: 'sidebar.reportDescription',
            icon: 'mdi-information',
            class: 'plainText',
            oneLineInput: true,
          },
          {
            name: 'NadawcaNazwa',
            translationPath: 'sidebar.senderName',
            icon: 'mdi-account-arrow-right',
            class: 'plainText',
          },
          {
            name: 'OdbiorcaNazwa',
            translationPath: 'sidebar.receiverName',
            icon: 'mdi-account-arrow-left',
            class: 'plainText',
          },
          {
            name: 'Przyjmujacy',
            translationPath: 'sidebar.host',
            icon: 'mdi-account-tie',
            class: 'plainText',
            hasDivider: true,
          },
        ],
      };
    },
  },
  methods: {
    editFailure: call('zdmFailures/editFailure'),
    deleteFailure: call('zdmFailures/deleteFailure'),
    getFailure: call('zdmFailures/getFailure'),
    searchStreets: call('search/searchStreets'),
    getDates(payload) {
      return {
        dateAccepted: payload['ZgloszenieDataPrzyjecia'],
        dateForwarded: payload['ZgloszenieDataPrzekazania'],
        dateConfirmed: payload['ZgloszenieDataPotwierdzenia'],
      };
    },
    async getFailureObject(id) {
      const r = await this.getFailure(id);
      const object = {
        ...r.properties,
        ...{ id: r.id },
        ...{ geometry: { ...r.geometry, ...{ crs: r.crs } } },
      };
      return object;
    },
    async handleFailureEditing(payload, objects) {
      console.log('');
      const failure_id = payload.id;
      delete payload.id;
      delete payload.geometry;
      const feature = {
        ...payload,
      };
      const features_to_assign = objects.add;
      const features_to_unassign = objects.delete;
      await this.editFailure({ failure_id, feature, features_to_assign, features_to_unassign });
    },
    async zoomToStreet(street) {
      const payload = {
        params: {
          limit: 20,
          search_text: street,
        },
      };
      try {
        const result = await this.searchStreets(payload);
        this.$root.$emit('createGeomAndFitView', result[0].geometry);
      } catch (e) {
        this.name = street;
        this.isDialogLoaded = true;
        this.isDialogVisible = true;
      }
    },
    searchInGoogle() {
      const address = `https://google.com/search?q=${this.name + ', Warszawa'}`;
      const link = document.createElement('a');
      link.setAttribute('href', address);
      link.setAttribute('target', '_blank');
      link.click();
      this.name = '';
      this.isDialogLoaded = false;
      this.isDialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.plainText {
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  padding-top: 4px;
}
.subHeader {
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: #00000096;
}
</style>
